import { createFileRoute } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { ClientsTable } from "./-pages/clientsTable";
import { FilterType } from "@quake/isomorphic";
import { useMemo } from "react";
import { useParams } from "@tanstack/react-router";

const tableName = "recruitment_clients";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/clients/")({
  component: RouteComponent,
  loader: async () => {
    const tablePrefs = await queryClient.fetchQuery(trpc.users.getTablePreferences.queryOptions({ tableName }));
    return {
      initialDataFilters: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.filters
        : tablePrefs.originalFilters,
      baseDataFilters: tablePrefs.originalFilters,

      initialColumnsDisplay: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.columnsDisplay
        : tablePrefs.defaultColumnsDisplay,
      baseColumnsDisplay: tablePrefs.defaultColumnsDisplay,

      initialColumnsOrder: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.columnsOrder
        : tablePrefs.defaultColumnsOrder,
      baseColumnsOrder: tablePrefs.defaultColumnsOrder,

      activeSort: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.sort
        : [],

      activePreferenceId: tablePrefs.activePreferenceId,
    };
  },
});

function RouteComponent() {
  const {
    initialDataFilters,
    baseDataFilters,
    initialColumnsOrder,
    initialColumnsDisplay,
    baseColumnsOrder,
    baseColumnsDisplay,
    activeSort,
    activePreferenceId,
  } = Route.useLoaderData();
  const { datasetSlug } = useParams({ from: "/_dashboard/$datasetSlug" });

  useBreadCrumbs([{ title: "Clients", link: `/${datasetSlug}/data/clients` }]);

  const parsedFilters = useMemo(() => initialDataFilters as Record<string, FilterType>, [initialDataFilters]);

  return (
    <ClientsTable
      initialDataFilters={parsedFilters}
      baseDataFilters={baseDataFilters}
      //
      initialColumnsDisplay={initialColumnsDisplay}
      baseColumnsDisplay={baseColumnsDisplay}
      //
      initialColumnsOrder={initialColumnsOrder}
      baseColumnsOrder={baseColumnsOrder}
      //
      activeSort={activeSort}
      activePreferenceId={activePreferenceId}
    />
  );
}
